import styled from 'styled-components'
import { sm } from '@ucheba/utils/helpers/styles/mixins'
import { Picture } from '@ucheba/ui/components/Picture'

const List = styled.div`
  width: 100%;
  display: flex;
  gap: 38px 48px;
  flex-wrap: wrap;

  ${sm.breakpoint.smAndDown`
    flex-wrap: nowrap;
    overflow-x: scroll;
    padding-bottom: 16px;
  `};
`

const Logo = styled(Picture)`
  height: 56px;
`

export default { List, Logo }
